const toMaskedDate = (value: string): string => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) {
        return digits;
    }
    if (digits.length <= 4) {
        return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    }
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const installGlobalDateInputMask = (doc: Document): void => {
    doc.addEventListener(
        'input',
        (event: Event) => {
            const target = event.target;
            if (!(target instanceof HTMLInputElement)) {
                return;
            }
            if (!target.classList.contains('mat-datepicker-input')) {
                return;
            }
            if (target.dataset['dateMasking'] === '1') {
                return;
            }

            const masked = toMaskedDate(target.value);
            if (masked === target.value) {
                return;
            }

            // Stop propagation of the raw value event and replay one with masked value
            // so Angular Material date parsing/validation receives DD/MM/YYYY.
            event.stopImmediatePropagation();
            target.value = masked;
            target.dataset['dateMasking'] = '1';
            target.dispatchEvent(new Event('input', { bubbles: true }));
            delete target.dataset['dateMasking'];
        },
        true
    );
};
